"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledgeProject.form.title.edit': 'Edytuj projekt',
    'knowledgeProject.form.title.add': 'Dodaj projekt',
    'knowledgeProject.form.back': 'Wstecz',
    'knowledgeProject.form.color.placeholder': '#007bff',
    'knowledgeProject.form.icon.placeholder': 'fas fa-folder',
};
